import React from "react";
import "./ProfilePicUpload.scss";
import profilePic from "../../../assets/icons/header/profile_pic.png";
import CropImageModal from "../CropImageModal/CropImageModal";

export default class ProfilePicUpload extends React.Component {
  state = {
    image: "",
    showCropImageModal: false,
  };

  onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      this.setState({
        image: URL.createObjectURL(img),
        showCropImageModal: true,
      });
    }
  };

  render() {
    return (
      <div className="profile-pic-upload">
        <img src={this.props.profilePic || profilePic} alt="Profile Icon" />
        <input
          type="file"
          id="file-upload"
          name="myImage"
          accept="image/*"
          onClick={(e) => {
            e.target.value = null;
          }}
          onChange={this.onImageChange}
        />
        <label htmlFor="file-upload">
          <p>Upload Photo</p>
        </label>
        <CropImageModal
          showModal={this.state.showCropImageModal}
          imageSrc={this.state.image}
          setProfilePicHandler={this.props.setProfilePicHandler}
          handleClose={() => this.setState({ showCropImageModal: false })}
          uploadImage={this.uploadImage}
        />
      </div>
    );
  }
}
